import { render } from "./Read.vue?vue&type=template&id=d2101d3c"
import script from "./Read.vue?vue&type=script&lang=js"
export * from "./Read.vue?vue&type=script&lang=js"

import "./Read.vue?vue&type=style&index=0&id=d2101d3c&lang=css"

import exportComponent from "C:\\Users\\Trix\\Documents\\manga-corporation-V2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__